import React, { useState } from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import useLazyImage from '../../hooks/useLazyImage';
import YelpModal from '../ui/YelpModal';
import './Reviews.css';

// Lazy Image Component for Review Logos
const LazyReviewLogo = ({ src, alt, onError }) => {
  const { elementRef, isLoaded, isInView } = useLazyImage(src);
  
  return (
    <div ref={elementRef} style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {isInView && (
        <img 
          src={src} 
          alt={alt}
          onError={onError}
          style={{
            opacity: isLoaded ? 1 : 0,
            transition: 'opacity 0.3s ease',
            width: '100%',
            height: 'auto'
          }}
          loading="lazy"
          decoding="async"
        />
      )}
      {!isInView && (
        <div style={{ width: '100%', height: '60px', background: '#f0f0f0', borderRadius: '8px' }}></div>
      )}
    </div>
  );
};

const Reviews = () => {
  const titleRef = useScrollAnimation();
  const [imageErrors, setImageErrors] = useState({});
  const [isYelpModalOpen, setIsYelpModalOpen] = useState(false);
  const reviewPlatforms = [
    {
      name: 'Google Reviews',
      logo: '/images/logos/Google-Review-Logo.png',
      link: 'https://www.google.com/search?sca_esv=c9bfdf3b8cae865b&hl=en&authuser=0&sxsrf=AE3TifPDM3Ol_ow1rTGMUIRgwhrmU61Kvw:1759293247026&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-EzuQ3ppSlrXGcwVjVa_bVhBBa_K1m_PhUX93-hbnm5G7PtosDXz4RjQG9qYZLwRbUVK6TWBfyW1C-uoiVviAO13Q4fFa&q=RC+Roofing+Reviews&sa=X&ved=2ahUKEwjyyq2IloKQAxVoavUHHetZEzoQ0bkNegQIHxAC&biw=2560&bih=945&dpr=1'
    },
    {
      name: 'Yelp',
      logo: '/images/logos/Yelp-Review-Logo.png',
      link: 'https://www.yelp.com/not_recommended_reviews/rc-roofing-detroit'
    }
  ];

  const handleReviewClick = (platform, link) => {
    if (platform === 'Yelp') {
      setIsYelpModalOpen(true);
    } else {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  const handleImageError = (platformName) => {
    setImageErrors(prev => ({
      ...prev,
      [platformName]: true
    }));
  };

  return (
    <section id="reviews" className="section reviews pad-12 pad-h-sm-6 pad-h-xs-0" aria-labelledby="reviews-title">
      <div className="container">
        <div className="reviews-card">
          <div className="reviews-header">
            <h2 id="reviews-title" ref={titleRef} className="reviews-title">Why Clients Trust Us</h2>
            <p className="reviews-subtitle pad-r-12 pad-h-sm-6 pad-h-xs-0">
            Here's what our customers have to say about their remodeling journey with us.
            </p>
          </div>
          
          <div className="reviews-links">
            {reviewPlatforms.map((platform, index) => (
              <button 
                key={platform.name}
                className="review-logo-button"
                onClick={() => handleReviewClick(platform.name, platform.link)}
                aria-label={`View ${platform.name}`}
              >
                {!imageErrors[platform.name] ? (
                  <LazyReviewLogo 
                    src={platform.logo} 
                    alt={`${platform.name} logo`}
                    onError={() => handleImageError(platform.name)}
                  />
                ) : (
                  <div className="fallback-logo">
                    {index === 0 ? '🔍' : '⭐'}
                    <span className="fallback-text">{platform.name}</span>
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
      
      <YelpModal 
        isOpen={isYelpModalOpen}
        onClose={() => setIsYelpModalOpen(false)}
      />
    </section>
  );
};

export default Reviews;
